module.exports = __webpack_public_path__ + "img/169.35796117.jpg";